export default {
  CampanhaVigente: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "campanha-vigente"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CampanhaVigente.js
// module id = Pwt0
// module chunks = 32